<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div :class="hasSearch ? 'field has-addons' : ''">
            <div :class="hasSearch ? 'control is-expanded' : ''">
                <money
                    ref="moneyInput"
                    :class="{
                        invalid: focusedOut && invalid && innerInvalidWhenDisabled,
                        'align-center': alingCenter,
                        'align-right': alingRight,
                    }"
                    :id="id"
                    :masked="false"
                    :precision="precision"
                    :decimal="decimal"
                    :thousands="thousands"
                    :prefix="prefix"
                    :suffix="suffix"
                    :value="value"
                    :disabled="disabled"
                    :tabindex="tabindex"
                    @input="updateValue"
                />
            </div>
            <div class="control" v-if="hasSearch">
                <a
                    class="button"
                    @click="searchAction"
                    :class="{ 'invalid-button': focusedOut && invalid }"
                >
                    <bue-icon icon="magnify" />
                </a>
            </div>
        </div>
        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="focusedOut && invalid && innerInvalidWhenDisabled"
        />
        <div class="clearfix" v-else-if="innerInvalidWhenDisabled && !noClearfix" />
    </div>
</template>

<script>
const MIN_PRECISION = 0;
const MAX_PRECISION = 8;
const MIN_VALUE = 0;
const MAX_VALUE = 9999999999999.99;
import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        title: {
            default: '',
            type: String,
        },
        value: {
            required: true,
            type: [Number, String],
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        masked: {
            type: Boolean,
            default: false,
        },
        precision: {
            type: Number,
            default: 2,
        },
        decimal: {
            type: String,
            default: ',',
        },
        thousands: {
            type: String,
            default: '.',
        },
        prefix: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        max: {
            type: Number,
            default: MAX_VALUE,
        },
        min: {
            type: Number,
            default: MIN_VALUE,
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        type: {
            default: '',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        hasSearch: {
            default: false,
            type: Boolean,
        },
        tabindex: {
            type: String,
            default: null,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        id: {
            default: null,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        alingCenter: {
            type: Boolean,
            default: false,
        },
        alingRight: {
            type: Boolean,
            default: false,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            focusedOut: false,
            display: '',
            innerInvalidWhenDisabled: false,
        };
    },
    mounted() {
        let input = this.$refs.moneyInput.$el;

        input.addEventListener('blur', this.validateOnBlur);
        input.addEventListener('keyup', this.keyEvent);
        input.addEventListener('focus', this.focusEvt);
    },
    created() {
        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);
    },
    methods: {
        validateOnBlur() {
            this.checkMinValue(this.value);
            this.focusedOut = true;
            this.$emit('blur');
            this.blurEvt();
        },
        keyEvent(event) {
            let keyCode = event.keyCode || event.which;

            if (keyCode == 9) {
                // ao clicar em tab
                this.$refs.moneyInput.$el.select();
            } else if (keyCode == 38) {
                // Aumentar valor - arow up
                let temp = this.value + 1;
                if (temp > this.max) return;
                this.updateValue(temp);
            } else if (keyCode == 40) {
                // diminuir valor - arrow down
                let temp = this.value - 1;
                if (temp < this.min) return;
                this.updateValue(temp);
            }
        },
        searchAction() {
            this.$emit('search-action');
        },
        updateValue(val) {
            if (val == this.value) return;

            let out = this.handleValue(val);

            this.$emit('input', out);

            if (this.$refs.moneyInput) {
                if (this.masked) {
                    this.$refs.moneyInput.$el.value = out;
                } else {
                    this.$refs.moneyInput.$el.value = this.formatValue(out);
                }
            }
        },
        handleValue(val) {
            let res = val || 0;

            if (Number(val) > this.max) {
                res = this.max;
            }

            if (Number(val) < this.min) {
                res = this.min;
            }

            if (this.masked) {
                return this.formatValue(Number(res));
            } else {
                return Number(res);
            }
        },
        checkMinValue(val) {
            let res = val || 0;

            if (Number(val) < this.min) {
                res = this.min;
            }

            this.updateValue(res);
        },
        unformatValue(input) {
            /* https://github.com/vuejs-tips/v-money/blob/master/src/utils.js */
            let negative = input.indexOf('-') >= 0 ? -1 : 1;
            let numbers = input.replace(/\D+/g, '') || '0';
            let currency = this.toCurrency(numbers);
            return parseFloat(currency) * negative;
        },
        formatValue(val) {
            /* https://github.com/vuejs-tips/v-money/blob/master/src/utils.js */
            let input = val.toFixed(this.fixedPrecision);
            let negative = input.indexOf('-') >= 0 ? '-' : '';
            let numbers = input.replace(/\D+/g, '') || '0';
            let currency = this.toCurrency(numbers);
            let parts = currency.split('.');
            let integer = parts[0];
            let decimal = parts[1];

            integer = integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${this.thousands}`);
            return (
                this.prefix +
                negative +
                (decimal ? integer + this.decimal + decimal : integer) +
                this.suffix
            );
        },
        toCurrency(numbers) {
            let exp = Math.pow(10, this.fixedPrecision);
            let float = parseFloat(numbers) / exp;
            return float.toFixed(this.fixedPrecision);
        },
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
    },
    computed: {
        fixedPrecision() {
            return Math.max(MIN_PRECISION, Math.min(this.precision, MAX_PRECISION));
        },
    },
};
</script>

<style lang="scss" scoped>
label {
    font-size: 12px;
    color: #666666;
    font-weight: 600;
}

span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}

.invalid {
    border: 1px solid $red-alert;
}

input {
    margin-bottom: 0 !important;
    color: #666666;
    height: 36px;
}

.field.has-addons {
    margin-bottom: 0;

    input {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    .button {
        height: 36px;
        color: #666666;
        border-color: $table-border;

        &.invalid-button {
            border-bottom-color: red;
            border-right-color: red;
            border-top-color: red;
        }
    }
}
.align-center{
    text-align: center;
}
.align-right{
    text-align: right;
}
</style>
